module.exports = __webpack_public_path__ + "static/img/crown-to-e-crown.b219729.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/innovations/crown-to-e-crown.png
// module id = Wf8Y
// module chunks = 1